import { PayloadAction } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';

import { CalendarEvent, DesignState } from 'editor/src/store/design/types';
import { CalendarCountriesEvents } from 'editor/src/store/gridConfig/types';

import { isSameCountries, mergeCountryHolidays } from 'editor/src/util/calendar/calendarCountries';

const isPublicHoliday = ({ custom, merchant }: CalendarEvent) => !custom && !merchant;

const setCalendarCountryHolidaysReducer = (state: DesignState, action: PayloadAction<CalendarCountriesEvents>) => {
  const calendar = state.designData?.calendar;
  // An answer for countries the design no longer has is stale.
  if (!calendar || !isSameCountries(calendar.countries, action.payload.countries)) {
    return;
  }

  const events = calendar.events || [];
  const currentHolidays = events.filter(isPublicHoliday);
  const holidays: CalendarEvent[] = mergeCountryHolidays(action.payload.countries, action.payload.events).map(
    ({ date, title, countries }) => {
      const eventDate = new Date(date);
      const day = eventDate.getUTCDate();
      const month = eventDate.getUTCMonth();
      const year = eventDate.getUTCFullYear();
      // Keep a holiday the user unticked unticked when the country list changes around it.
      const current = currentHolidays.find(
        (event) => event.day === day && event.month === month && event.year === year && event.label === title,
      );
      return {
        // From the date and name, which no other public holiday shares: a reducer must not generate random ids.
        id: current?.id ?? `public-holiday-${date}-${title}`,
        day,
        month,
        year,
        label: title,
        checked: current?.checked ?? true,
        custom: false,
        merchant: false,
        countries,
      };
    },
  );

  if (isEqual(holidays, currentHolidays)) {
    return;
  }

  calendar.events = [...events.filter((event) => !isPublicHoliday(event)), ...holidays];
};

export default setCalendarCountryHolidaysReducer;
